var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "10", height: "20", viewBox: "0 0 10 20", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M4.4,14.0514719 L4.4,6.5 C4.4,5.7 5.6,5.7 5.6,6.5 L5.6,14.0514719 L7.07573593,12.5757359 C7.31005051,12.3414214 7.68994949,12.3414214 7.92426407,12.5757359 C8.15857864,12.8100505 8.15857864,13.1899495 7.92426407,13.4242641 L5.42426407,15.9242641 C5.18994949,16.1585786 4.81005051,16.1585786 4.57573593,15.9242641 L2.07573593,13.4242641 C1.84142136,13.1899495 1.84142136,12.8100505 2.07573593,12.5757359 C2.31005051,12.3414214 2.68994949,12.3414214 2.92426407,12.5757359 L4.4,14.0514719 Z", fill: "#000000", fillRule: "nonzero", transform: "matrix(1 0 0 -1 0 22)" })
  );
});